var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-filter-remove",on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon-cross-small'),_vm._v("Сбросить все")],1)}
var staticRenderFns = []

export { render, staticRenderFns }